import { getEnviromentDetails } from './env-utils';

export function resolveGraphqlBaseUrl(): string {
  const baseUrl = getEnviromentDetails().graphBaseUrl;

  return baseUrl;
}

export function resolveIdentityBaseUrl(): string {
  const baseUrl = getEnviromentDetails().identityBaseUrl;

  return baseUrl;
}

export function resolveMainHostUrl(): string {
  const baseUrl = getEnviromentDetails().mainHostUrl;

  return baseUrl;
}
